"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const app_platform_value_type_definitions_1 = require("@semios/app-platform-value-type-definitions");
const zod_1 = require("zod");
const regionValueTypes = app_platform_value_type_definitions_1.VC.valuesCurrentValueTypes_Regions;
const allowedRegionValueTypes = [
    'air_temperature_sidekick',
    'degree_days_insect_id_1_sidekick',
    'degree_days_insect_id_10_sidekick',
    'degree_days_insect_id_11_sidekick',
    'degree_days_insect_id_12_sidekick',
    'degree_days_insect_id_13_sidekick',
    'degree_days_insect_id_14_sidekick',
    'degree_days_insect_id_15_sidekick',
    'degree_days_insect_id_16_sidekick',
    'degree_days_insect_id_17_sidekick',
    'degree_days_insect_id_18_sidekick',
    'degree_days_insect_id_19_sidekick',
    'degree_days_insect_id_2_sidekick',
    'degree_days_insect_id_20_sidekick',
    'degree_days_insect_id_23_sidekick',
    'degree_days_insect_id_24_sidekick',
    'degree_days_insect_id_25_sidekick',
    'degree_days_insect_id_26_sidekick',
    'degree_days_insect_id_27_sidekick',
    'degree_days_insect_id_28_sidekick',
    'degree_days_insect_id_29_sidekick',
    'degree_days_insect_id_3_sidekick',
    'degree_days_insect_id_30_sidekick',
    'degree_days_insect_id_4_sidekick',
    'degree_days_insect_id_5_sidekick',
    'degree_days_insect_id_6_sidekick',
    'degree_days_insect_id_7_sidekick',
    'degree_days_insect_id_8_sidekick',
    'degree_days_insect_id_9_sidekick',
    'dewPoint_minMedianMax_in_c',
    'humidity_minMedianMax_in_pct',
    'precipitation_next24HoursSumMinMedianMax_mm',
    'precipitation_following7DaysSumMinMedianMax_mm',
    'precipitation_last24HoursSumMinMedianMax_mm',
    'precipitation_previous7DaysSumMinMedianMax_mm',
    'temperature_minMedianMax_in_c',
    'trap_catches_insect_id_1_sidekick',
    'trap_catches_insect_id_10_sidekick',
    'trap_catches_insect_id_11_sidekick',
    'trap_catches_insect_id_12_sidekick',
    'trap_catches_insect_id_15_sidekick',
    'trap_catches_insect_id_16_sidekick',
    'trap_catches_insect_id_17_sidekick',
    'trap_catches_insect_id_19_sidekick',
    'trap_catches_insect_id_2_sidekick',
    'trap_catches_insect_id_20_sidekick',
    'trap_catches_insect_id_25_sidekick',
    'trap_catches_insect_id_27_sidekick',
    'trap_catches_insect_id_28_sidekick',
    'trap_catches_insect_id_29_sidekick',
    'trap_catches_insect_id_30_sidekick',
    'trap_catches_insect_id_6_sidekick',
    'trap_catches_insect_id_7_sidekick',
    'trap_catches_insect_id_9_sidekick',
    'weatherForecastDaily',
    'weatherForecastHourly',
    'weatherIcon',
    'wetBulb_minMedianMax_in_c',
    'windSpeed_minMedianMax_mps',
    'windDirection_average_degrees',
];
const allowedValueTypesEnum = zod_1.z.enum(allowedRegionValueTypes);
exports.requestSchema = zod_1.z.object({
    regions: zod_1.z.object({
        regionIds: zod_1.z.array(zod_1.z.string().uuid()),
        values: zod_1.z.record(allowedValueTypesEnum, zod_1.z.boolean()),
    }),
});
exports.path = '/landing-page-values-current';
//# sourceMappingURL=index.js.map